export const PIECETYPE = Object.freeze({
    CROSS: 1,
    CIRCLE: 2,
    NONE: 0
  });